<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid class="pt-0">
                <div class="mb-8">
                    <h1 class="fs-20">SNS 가입</h1>
                    <p class="fs-13 fw-400 subtitle--text mt-1">
                        소셜계정으로 회원가입을 진행해요.
                </p>
                </div>
                <v-form class="form-item" v-model="valid">
                    <label class="label fw-600">계정 정보</label>
                    <!-- ic_kakao2.svg, ic_narver.svg, ic_google.svg, ic_apple.svg -->
                    <div class="d-flex align-center mb-6"><img :src="getImage('ic_kakao2.svg')" class="mr-2" width="24">dkdk@dkbrothers.co.kr</div>
                    <label class="label fw-600">생년월일</label>
                    <div class="input-group">
                        <v-text-field solo flat filled v-model="birthday" :rules="birthday_rule" required
                            placeholder="생년월일" />
                    </div>
                    <label class="label fw-600">성별</label>
                    <div class="input-group">
                        <v-radio-group
                            v-model="gender"
                            row
                            mandatory
                            active-class="active"
                            >
                            <v-radio
                                label="남자"
                                value="men"
                                class="radio"
                            ></v-radio>
                            <v-radio
                                label="여자"
                                value="woman"
                                class="radio"
                            ></v-radio>
                        </v-radio-group>
                    </div>
                    <label class="label fw-600">닉네임</label>
                    <div class="input-group">
                        <v-text-field solo flat filled v-model="nickname" :rules="nickname_rule" required
                            placeholder="한글, 영문, 숫자 혼용하여 10자" />
                        <v-btn elevation="0" :ripple="false" color="black" width="90" height="48"
                        class="fs-14 white--text ml-2">중복 검사</v-btn>
                    </div>
                </v-form>
            </v-container>
            <div class="footer-btns">
                <BlackBtn str="다음" :disabled="true" />
            </div>
        </v-layout>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
export default {
    data: () => ({
        valid: false,
        email: "",
        password: "",
        repassword: "",
        birthday: "",
        gender: null,
        nickname: "",
    }),
    components: {
        BlackBtn,
    },
    computed: {
        email_rule() {
            return [(v) => !!v || "이메일을 올바르게 입력해주세요."];
        },
        password_rule() {
            return [(v) => !!v || "비밀번호를 올바르게 입력해주세요."];
        },
        repassword_rule() {
            return [(v) => !!v || "비밀번호가 일치하지 않습니다."];
        },
        birthday_rule() {
            return [(v) => !!v || ""];
        },
        nickname_rule() {
            return [(v) => !!v || "중복된 닉네임이 있습니다."];
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep.v-input--radio-group{
    margin-top: 0;
    padding-top: 0;
    flex: 1 1 auto !important;
    .v-input--radio-group__input{
        gap: 14px;
    }
    .radio {
        flex: 1;
        .v-input--selection-controls__input {
        display: none;
        }
        .v-label {
        height: 48px;
        border: 1px solid #D9D9D9;
        border-radius: 10px;
        color: #212529;
        justify-content: center;
        }
        &.active {
        .v-label {
            background: #000;
            color: #fff;
        }
        }
    }
}
</style>